<!-- Dialog Template -->
<ng-template #dialogContent>
    <div class="spline-dialog-content">

        <!-- Header Info -->
        <div class="header-info">
            <div class="form-group compact">
                <label class="form-label">İsim</label>
                <input type="text" class="form-input" [(ngModel)]="isim" placeholder="Spline.X">
            </div>

            <!-- Aktif Body (kompakt) -->
            @if (!duzenleModu) {
            <div class="form-group compact aktif-body-group">
                <div class="body-header">
                    <label class="form-label">Body</label>
                    <label class="body-toggle mini">
                        <input type="checkbox" [(ngModel)]="aktifBodyeEkle">
                    </label>
                </div>
                @if (aktifBodyeEkle) {
                <div class="body-picker compact">
                    <input type="text" class="form-input body-input"
                           [value]="seciliAktifBodyIsim" readonly
                           [class.selecting]="bodySecModu">
                    <button class="pick-btn mini" [class.active]="bodySecModu"
                            title="Ürün ağacından seç">
                        <i class="crosshairs icon"></i>
                    </button>
                </div>
                }
            </div>
            }

            <div class="info-row">
                <span class="info-label">Nokta:</span>
                <span class="info-value">{{ noktalar.length }}</span>
                <span class="info-label">Uzunluk:</span>
                <span class="info-value">{{ toplamUzunluk }} mm</span>
            </div>
        </div>

        <!-- Tab Navigation -->
        <div class="tab-navigation">
            <button class="tab-btn" [class.active]="aktifTab === 'noktalar'" (click)="aktifTab = 'noktalar'" title="Kontrol Noktaları">
                <i class="map marker alternate icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'sekil'" (click)="aktifTab = 'sekil'" title="Hazır Şekil">
                <i class="shapes icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'egri'" (click)="aktifTab = 'egri'" title="Eğri Ayarları">
                <i class="bezier curve icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'stil'" (click)="aktifTab = 'stil'" title="Stil">
                <i class="paint brush icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifTab === 'diger'" (click)="aktifTab = 'diger'" title="Diğer">
                <i class="cog icon"></i>
            </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">

            <!-- Noktalar Tab -->
            @if (aktifTab === 'noktalar') {
            <div class="tab-pane noktalar-pane">
                <!-- Kapalı toggle -->
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="kapali" (ngModelChange)="kapaliDegisti()">
                        Kapalı Eğri
                    </label>
                </div>

                <!-- Nokta listesi (kompakt) -->
                <div class="nokta-listesi">
                    @for (nokta of noktalar; track $index; let i = $index) {
                    <div class="nokta-item" [class.secili]="seciliNoktaIndex === i" [class.picking]="noktaSecModu === i" (click)="noktaDuzenleDialogAc(i)">
                        <button class="pick-btn nokta-pick" [class.active]="noktaSecModu === i"
                                (click)="noktaSecBaslat(i); $event.stopPropagation()" title="3D'den seç">
                            <i class="crosshairs icon"></i>
                        </button>
                        <span class="nokta-index">{{ i + 1 }}</span>
                        <span class="nokta-ozet">
                            {{ nokta.x | number:'1.0-1' }}, {{ nokta.y | number:'1.0-1' }}, {{ nokta.z | number:'1.0-1' }}
                        </span>
                        <div class="nokta-actions">
                            @if (i < noktalar.length - 1) {
                            <button class="btn-icon btn-tiny" title="Arasına ekle" (click)="arayaNoktaEkle(i); $event.stopPropagation()">
                                <i class="plus icon"></i>
                            </button>
                            }
                            <button class="btn-icon btn-tiny btn-danger" title="Sil" (click)="noktaSil(i); $event.stopPropagation()">
                                <i class="trash icon"></i>
                            </button>
                        </div>
                    </div>
                    }
                </div>

                <!-- Düzlem Seçimi -->
                <div class="duzlem-secimi">
                    <div class="duzlem-header">
                        <label>Düzlem</label>
                        <span class="duzlem-mini-ozet" [class.kamera-modu]="duzlemKameraTakip">
                            {{ duzlemKameraTakip ? 'Kamera' : (seciliYuzeyIsmi || 'Sabit') }}
                        </span>
                        <button class="pick-btn duzlem-kamera" [class.active]="duzlemKameraTakip"
                                (click)="duzlemKameraModuAc()" title="Kamera takip (serbest)">
                            <i class="video icon"></i>
                        </button>
                        <button class="pick-btn duzlem-ayar" [class.active]="duzlemAyarGoster"
                                (click)="duzlemAyarGoster = !duzlemAyarGoster" title="Düzlem parametreleri">
                            <i class="cog icon"></i>
                        </button>
                    </div>

                    @if (duzlemAyarGoster && !duzlemKameraTakip) {
                    <div class="duzlem-ayarlar">
                        <div class="duzlem-ozet">
                            <span class="duzlem-formul">
                                <span class="koef">{{ duzlemNormal.x | number:'1.2-2' }}</span>x +
                                <span class="koef">{{ duzlemNormal.y | number:'1.2-2' }}</span>y +
                                <span class="koef">{{ duzlemNormal.z | number:'1.2-2' }}</span>z +
                                <span class="koef">{{ duzlemD | number:'1.2-2' }}</span> = 0
                            </span>
                        </div>
                        <div class="normal-inputs">
                            <div class="coord-input">
                                <label>i</label>
                                <input type="number" [(ngModel)]="duzlemNormal.x" (ngModelChange)="duzlemGuncelle(false)" step="0.1">
                            </div>
                            <div class="coord-input">
                                <label>j</label>
                                <input type="number" [(ngModel)]="duzlemNormal.y" (ngModelChange)="duzlemGuncelle(false)" step="0.1">
                            </div>
                            <div class="coord-input">
                                <label>k</label>
                                <input type="number" [(ngModel)]="duzlemNormal.z" (ngModelChange)="duzlemGuncelle(false)" step="0.1">
                            </div>
                            <div class="coord-input">
                                <label>d</label>
                                <input type="number" [(ngModel)]="duzlemD" (ngModelChange)="duzlemGuncelle(false)" step="1">
                            </div>
                        </div>
                        <div class="duzlem-buttons">
                            <button class="btn-icon" (click)="duzlemNormalize()" title="Normalize">
                                <i class="sync icon"></i>
                            </button>
                            <button class="btn-icon btn-kamera" (click)="duzlemKameraModuAc()" title="Kamera moduna dön">
                                <i class="video icon"></i>
                            </button>
                        </div>
                    </div>
                    }

                    @if (duzlemAyarGoster && duzlemKameraTakip) {
                    <div class="duzlem-kamera-info">
                        <i class="video icon"></i>
                        Kamera yönünde serbest çizim
                    </div>
                    }
                </div>

                <!-- Nokta ekle butonları -->
                <div class="nokta-ekle-buttons">
                    <button class="btn-icon btn-add" (click)="noktaEkle()" title="Nokta ekle">
                        <i class="plus icon"></i>
                    </button>
                    <button class="btn-icon btn-add btn-3d" [class.active]="noktaSecModu === noktalar.length"
                            (click)="noktaSecBaslat(noktalar.length)" title="3D'den tek nokta ekle">
                        <i class="crosshairs icon"></i>
                    </button>
                    <button class="btn-icon btn-add btn-ardisik" [class.active]="ardisikTiklamaModu"
                            (click)="ardisikTiklamaToggle()"
                            [title]="ardisikTiklamaModu ? 'Ardışık modu durdur (sağ tık)' : 'Ardışık nokta ekle'">
                        <i class="mouse pointer icon"></i>
                    </button>
                </div>

                <!-- Ardışık mod bilgisi -->
                @if (ardisikTiklamaModu) {
                <div class="ardisik-info">
                    <i class="info circle icon"></i>
                    Tıkla = ekle. <strong>Sağ tık</strong> = bitir.
                </div>
                }
            </div>
            }

            <!-- Şekil Tab -->
            @if (aktifTab === 'sekil') {
            <div class="tab-pane sekil-pane">
                <!-- Hazır şekil seçimi -->
                <div class="sekil-secim-grid">
                    <button class="sekil-btn" [class.active]="hazirSekil === 'serbest'"
                            (click)="hazirSekil = 'serbest'; hazirSekilDegisti()" title="Serbest Çizim">
                        <i class="pencil alternate icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'sinus'"
                            (click)="hazirSekil = 'sinus'; hazirSekilDegisti()" title="Sinüs Dalgası">
                        <i class="wave square icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'spiral'"
                            (click)="hazirSekil = 'spiral'; hazirSekilDegisti()" title="Spiral">
                        <i class="sync icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'elips'"
                            (click)="hazirSekil = 'elips'; hazirSekilDegisti()" title="Elips">
                        <i class="circle outline icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'kalp'"
                            (click)="hazirSekil = 'kalp'; hazirSekilDegisti()" title="Kalp">
                        <i class="heart icon"></i>
                    </button>
                    <button class="sekil-btn" [class.active]="hazirSekil === 'sonsuzluk'"
                            (click)="hazirSekil = 'sonsuzluk'; hazirSekilDegisti()" title="Sonsuzluk">
                        <i class="infinity icon"></i>
                    </button>
                </div>

                @if (hazirSekil !== 'serbest') {
                <!-- Şekil parametreleri -->
                <div class="sekil-params-dikey">
                    <div class="param-row">
                        <label>X</label>
                        <input type="number" [(ngModel)]="sekilMerkezX" (ngModelChange)="sekilParametresiDegisti()" step="1">
                    </div>
                    <div class="param-row">
                        <label>Y</label>
                        <input type="number" [(ngModel)]="sekilMerkezY" (ngModelChange)="sekilParametresiDegisti()" step="1">
                    </div>
                    <div class="param-row">
                        <label>Z</label>
                        <input type="number" [(ngModel)]="sekilMerkezZ" (ngModelChange)="sekilParametresiDegisti()" step="1">
                    </div>

                    @if (hazirSekil === 'sinus') {
                    <div class="param-row">
                        <label>Dalga</label>
                        <input type="number" [(ngModel)]="sinusDalgaSayisi" (ngModelChange)="sekilParametresiDegisti()" min="1" max="10" step="1" title="Dalga Sayısı">
                    </div>
                    <div class="param-row">
                        <label>Genlik</label>
                        <input type="number" [(ngModel)]="sinusGenlik" (ngModelChange)="sekilParametresiDegisti()" min="5" step="5" title="Genlik">
                    </div>
                    <div class="param-row">
                        <label>Uzunluk</label>
                        <input type="number" [(ngModel)]="sinusUzunluk" (ngModelChange)="sekilParametresiDegisti()" min="50" step="10" title="Uzunluk">
                    </div>
                    }

                    @if (hazirSekil === 'spiral') {
                    <div class="param-row">
                        <label>Başl.R</label>
                        <input type="number" [(ngModel)]="spiralBaslangicYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Başlangıç Yarıçapı">
                    </div>
                    <div class="param-row">
                        <label>Bit.R</label>
                        <input type="number" [(ngModel)]="spiralBitisYaricap" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Bitiş Yarıçapı">
                    </div>
                    <div class="param-row">
                        <label>Tur</label>
                        <input type="number" [(ngModel)]="spiralTurSayisi" (ngModelChange)="sekilParametresiDegisti()" min="1" max="10" step="1" title="Tur Sayısı">
                    </div>
                    }

                    @if (hazirSekil === 'elips') {
                    <div class="param-row">
                        <label>Rx</label>
                        <input type="number" [(ngModel)]="elipsYaricapX" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="X Yarıçapı">
                    </div>
                    <div class="param-row">
                        <label>Ry</label>
                        <input type="number" [(ngModel)]="elipsYaricapY" (ngModelChange)="sekilParametresiDegisti()" min="1" step="5" title="Y Yarıçapı">
                    </div>
                    <div class="param-row">
                        <label>Nokta</label>
                        <input type="number" [(ngModel)]="elipsNoktaSayisi" (ngModelChange)="sekilParametresiDegisti()" min="6" max="48" step="1" title="Nokta Sayısı">
                    </div>
                    }
                </div>
                }
            </div>
            }

            <!-- Eğri Tab -->
            @if (aktifTab === 'egri') {
            <div class="tab-pane egri-pane">
                <div class="setting-row">
                    <label>Spline Tipi</label>
                    <select [(ngModel)]="splineTipi" (ngModelChange)="splineTipiDegisti()">
                        @for (tip of splineTipiSecenekleri; track tip.deger) {
                        <option [value]="tip.deger">{{ tip.etiket }}</option>
                        }
                    </select>
                </div>

                @if (splineTipi === 'catmull-rom') {
                <div class="setting-row">
                    <label>Catmull Tipi</label>
                    <select [(ngModel)]="catmullTipi" (ngModelChange)="catmullTipiDegisti()">
                        @for (tip of catmullTipiSecenekleri; track tip.deger) {
                        <option [value]="tip.deger">{{ tip.etiket }}</option>
                        }
                    </select>
                </div>

                <div class="setting-row">
                    <label>Tension</label>
                    <input type="range" [(ngModel)]="tension" (ngModelChange)="tensionDegisti()" min="0" max="1" step="0.05">
                    <span class="value-display">{{ tension }}</span>
                </div>
                }

                <div class="setting-row">
                    <label>Çözünürlük</label>
                    <input type="range" [(ngModel)]="segmentSayisi" (ngModelChange)="segmentSayisiDegisti()" min="10" max="200" step="5">
                    <span class="value-display">{{ segmentSayisi }}</span>
                </div>

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="kontrolNoktaGoster" (ngModelChange)="kontrolNoktaGosterDegisti()">
                        Kontrol Noktaları
                    </label>
                </div>

                @if (splineTipi.startsWith('bezier')) {
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="kontrolCizgiGoster" (ngModelChange)="kontrolCizgiGosterDegisti()">
                        Kontrol Çizgileri
                    </label>
                </div>
                }
            </div>
            }

            <!-- Stil Tab -->
            @if (aktifTab === 'stil') {
            <div class="tab-pane stil-pane">
                <div class="setting-row">
                    <label>Tip</label>
                    <select [(ngModel)]="cizgiTipi" (ngModelChange)="cizgiTipiDegisti()">
                        @for (tip of cizgiTipiSecenekleri; track tip.deger) {
                        <option [value]="tip.deger">{{ tip.etiket }}</option>
                        }
                    </select>
                </div>

                <div class="setting-row">
                    <label>Renk</label>
                    <input type="color" [(ngModel)]="renk" (ngModelChange)="renkDegisti()">
                </div>

                @if (cizgiTipi === 'Line2') {
                <div class="setting-row">
                    <label>Kalınlık</label>
                    <input type="range" [(ngModel)]="kalinlik" (ngModelChange)="kalinlikDegisti()" min="1" max="20" step="0.5">
                    <span class="value-display">{{ kalinlik }}</span>
                </div>
                }

                <div class="setting-row">
                    <label>Opaklık</label>
                    <input type="range" [(ngModel)]="opaklik" (ngModelChange)="opaklikDegisti()" min="0" max="1" step="0.1">
                    <span class="value-display">{{ opaklik }}</span>
                </div>

                <div class="setting-row">
                    <label>Stil</label>
                    <select [(ngModel)]="stil" (ngModelChange)="stilDegisti()">
                        @for (s of stilSecenekleri; track s.deger) {
                        <option [value]="s.deger">{{ s.etiket }}</option>
                        }
                    </select>
                </div>

                @if (stil === 'kesikli' || stil === 'kesikli-noktali') {
                <div class="setting-row">
                    <label>Kesik</label>
                    <input type="number" [(ngModel)]="kesikliBoyut" (ngModelChange)="stilDegisti()" min="1" max="50">
                </div>
                <div class="setting-row">
                    <label>Aralık</label>
                    <input type="number" [(ngModel)]="kesikliAralik" (ngModelChange)="stilDegisti()" min="1" max="50">
                </div>
                }

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="noktaGoster" (ngModelChange)="noktaGosterDegisti()">
                        Köşe noktaları
                    </label>
                </div>

                @if (noktaGoster) {
                <div class="setting-row">
                    <label>Boyut</label>
                    <input type="number" [(ngModel)]="noktaBoyutu" (ngModelChange)="noktaGosterDegisti()" min="1" max="20">
                </div>
                <div class="setting-row">
                    <label>Renk</label>
                    <input type="color" [(ngModel)]="noktaRengi" (ngModelChange)="noktaGosterDegisti()">
                </div>
                }
            </div>
            }

            <!-- Diğer Tab -->
            @if (aktifTab === 'diger') {
            <div class="tab-pane diger-pane">
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="enUstte" (ngModelChange)="enUsteDegisti()">
                        En üstte
                    </label>
                </div>
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="renderEt" (ngModelChange)="renderEtDegisti()">
                        Render et
                    </label>
                </div>
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="secilebilir" (ngModelChange)="secilebilirDegisti()">
                        Seçilebilir
                    </label>
                </div>
                <div class="setting-row">
                    <label>Katman</label>
                    <input type="number" [(ngModel)]="katman" min="0" max="31" step="1">
                </div>
                <div class="setting-row">
                    <button class="btn-icon btn-reset" (click)="sifirla()" title="Sıfırla">
                        <i class="redo icon"></i>
                    </button>
                </div>
            </div>
            }

        </div>

        <!-- Footer Actions -->
        <div class="dialog-footer">
            @if (duzenleModu) {
            <button class="btn-icon btn-primary" (click)="guncelle()" title="Güncelle">
                <i class="save icon"></i>
            </button>
            } @else {
            <button class="btn-icon btn-primary" (click)="olustur()" title="Oluştur">
                <i class="check icon"></i>
            </button>
            }
            <button class="btn-icon btn-secondary" (click)="kapat()" title="İptal">
                <i class="close icon"></i>
            </button>
        </div>

    </div>
</ng-template>

<!-- Koordinat Düzenleme Mini Dialog -->
@if (koordinatDialogAcik && koordinatDialogIndex !== null) {
<div class="koordinat-dialog-overlay" (click)="koordinatDialogKapat()">
    <div class="koordinat-dialog" (click)="$event.stopPropagation()">
        <div class="koordinat-header">
            <span>Nokta {{ koordinatDialogIndex + 1 }}</span>
            <button class="close-btn" (click)="koordinatDialogKapat()">
                <i class="close icon"></i>
            </button>
        </div>
        <div class="koordinat-content">
            <div class="coord-row">
                <label>X</label>
                <input type="number" [(ngModel)]="noktalar[koordinatDialogIndex].x" (ngModelChange)="noktaDegisti()" step="1" autofocus>
            </div>
            <div class="coord-row">
                <label>Y</label>
                <input type="number" [(ngModel)]="noktalar[koordinatDialogIndex].y" (ngModelChange)="noktaDegisti()" step="1">
            </div>
            <div class="coord-row">
                <label>Z</label>
                <input type="number" [(ngModel)]="noktalar[koordinatDialogIndex].z" (ngModelChange)="noktaDegisti()" step="1">
            </div>
        </div>
        <div class="koordinat-footer">
            <button class="btn-icon" [class.active]="noktaSecModu === koordinatDialogIndex"
                    (click)="noktaSecBaslat(koordinatDialogIndex)" title="3D'den seç">
                <i class="crosshairs icon"></i>
            </button>
            <button class="btn-icon btn-primary" (click)="koordinatDialogKapat()" title="Tamam">
                <i class="check icon"></i>
            </button>
        </div>
    </div>
</div>
}

<!-- Standalone Dialog -->
@if (gorunur && !pencere) {
<div class="spline-dialog-standalone">
    <div class="dialog-header">
        <span>{{ duzenleModu ? 'Spline Düzenle' : '3D Spline' }}</span>
        <button class="close-btn" (click)="kapat()"><i class="close icon"></i></button>
    </div>
    <div class="dialog-content">
        <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
    </div>
</div>
}

<!-- FikoDialogService ile kullanım -->
@if (pencere) {
<ng-container *ngTemplateOutlet="dialogContent"></ng-container>
}
